import React, { useContext, useEffect, useState } from 'react'
import Keyboard from 'react-simple-keyboard'
import { MathFieldContext } from './mathInput/mathfieldContext'
import $ from 'jquery'

function AlphabeticKeyboard({
  keyboard,
  layoutDesign,
  nameLayout,
  onKeyPress,
  onChange,
  buttonTheme,
  display,
}) {
  const mathfield = useContext(MathFieldContext)

  useEffect(() => {
    if (mathfield && typeof mathfield.focus === 'function') {
      $(`#mq-keyboard-def-${mathfield.id}`).css('bottom', `0px`)
    }
  }, [mathfield])

  const onMouseDown = (e) => {
    if (e.target instanceof HTMLElement && e.target.nodeName !== 'SELECT') {
      e.preventDefault()
      if (mathfield && typeof mathfield.focus === 'function') {
        mathfield.focus()
      }
    }
  }

  return (
    <React.Fragment>
      {/* Main layout */}
      <div
        id={`mq-keyboard-def-${mathfield.id}`}
        onMouseDown={onMouseDown}
        className="col-span-1 sm:col-span-2 lg:col-span-3 bg-white lg:me-[10px]"
      >
        <Keyboard
          baseClass={'bg-white'}
          keyboardRef={(r) => (keyboard.current = r)}
          layout={layoutDesign}
          layoutName={nameLayout}
          onChange={onChange}
          display={display}
          onKeyPress={onKeyPress}
          physicalKeyboardHighlight={true}
          syncInstanceInputs={false}
          mergeDisplay={true}
          debug={false}
          buttonTheme={buttonTheme}
        />
      </div>
    </React.Fragment>
  )
}

export default AlphabeticKeyboard
